import { render, staticRenderFns } from "./AllRatingsView.vue?vue&type=template&id=682f1a6c&scoped=true"
import script from "./AllRatingsView.vue?vue&type=script&lang=js"
export * from "./AllRatingsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682f1a6c",
  null
  
)

export default component.exports